import { Controller } from "@hotwired/stimulus";

// SP表示時の購入履歴テーブルの列表示/非表示切り替え
export class TableColumnToggleController extends Controller {
  toggle(event) {
    const btn = event.currentTarget;
    const col = btn.dataset.col;
    const isCollapsed = btn.classList.contains('is-collapsed');

    // 対象列の td をまとめて切り替え
    this.element.querySelectorAll(`td[data-col="${col}"]`).forEach(td => {
      td.classList.toggle('is-col-hidden', !isCollapsed);
    });

    // ボタンの状態切り替え（collapsed = 非表示中 = "＋"）
    btn.classList.toggle('is-collapsed');
    btn.textContent = isCollapsed ? '－' : '＋';
  }
}
